module.exports = __webpack_public_path__ + "static/media/11_crear_menu_plantilla_galeria_negra.9b4febe5.png";